import { Card, Space, Typography } from "antd";
import { GroupIcon } from "../groupIcon/groupIcon";
import { PermissionRow } from "./permissionRow/permissionRow";
import styles from "./permissionList.module.scss";

const { Title } = Typography;

export const PermissionList = ({
  group,
  permissionById,
  selected,
  unmetFor,
  brokenFor,
  onToggle,
}) => {
  const enabledCount = group.permissions.filter((p) => selected[p.id]).length;

  return (
    <Card bordered={false} bodyStyle={{ padding: 16 }}>
      <Space direction="vertical" style={{ width: "100%" }} size={24}>
        <div className={styles.permissionList__head}>
          <Space size={12} align="center">
            <Title level={4} className="section__title">
              <GroupIcon
                icon={group.icon}
                className={styles.permissionList__icon}
              />
              {group.name}
            </Title>
          </Space>

          <span className={styles.permissionList__count}>
            <strong>{enabledCount}</strong> of{" "}
            <strong>{group.permissions.length}</strong> enabled
          </span>
        </div>

        <div className={styles.permissionList__rows}>
          {group.permissions.map((permission) => (
            <PermissionRow
              key={permission.id}
              permission={permission}
              permissionById={permissionById}
              on={!!selected[permission.id]}
              unmet={unmetFor(permission.id)}
              broken={brokenFor(permission.id)}
              onToggle={() => onToggle(permission.id)}
            />
          ))}
        </div>
      </Space>
    </Card>
  );
};
